/** Ekrany przed zalogowaniem (Issue 41, 42) — nie są adresem powrotu i nie wymagają sesji. */
export const AUTH_PAGES = ['/logowanie', '/dostep', '/oferta', '/nie-pamietam-hasla', '/ustaw-haslo', '/wylogowano'];

export function isAuthPage(url: string): boolean {
    const path = url.split(/[?#]/)[0];

    return AUTH_PAGES.some((page) => path === page || path.startsWith(page + '/'));
}

/** Adres powrotu po zalogowaniu: tylko ścieżka panelu — bez innej domeny („//”, „/\\”) i bez ekranów logowania. */
export function safeReturnUrl(value: string | null | undefined): string | null {
    if (!value || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\') || isAuthPage(value)) {
        return null;
    }

    return value;
}

/** Klucz tekstu „Po zalogowaniu wrócisz do: …” (`auth.return.*`) i parametry. */
export function returnLabel(url: string): { key: string; params?: Record<string, string> } {
    const path = url.split(/[?#]/)[0];
    const detail = path.match(/^\/(sprawy|pojazdy|polisy|finansowanie)\/([^/]+)/);

    if (detail) {
        return detail[1] === 'sprawy'
            ? { key: 'auth.return.case', params: { id: decodeURIComponent(detail[2]) } }
            : { key: `auth.return.${detail[1]}Detail` };
    }

    const pages: Record<string, string> = {
        '/': 'home',
        '/sprawy': 'cases',
        '/pojazdy': 'vehicles',
        '/polisy': 'policies',
        '/finansowanie': 'financing',
        '/dokumenty': 'documents',
        '/konto': 'account',
    };

    return { key: `auth.return.${pages[path] ?? 'other'}` };
}
